import axios from 'axios';
import { baseUrl, token } from '../../../services/Apis';

export const PERIODOS_ACADEMICOS_CONST = 'periodosAcademicos';
export const periodosAcademicosApi = `${baseUrl}/periodos-academicos`;

export const allPeriodosAcademicosService = async (params) => {
  const res = await axios.get(periodosAcademicosApi, {
    headers: token({}),
    params,
  });
  return res;
};

export const savePeriodosAcademicosService = async (id, data) => {
  let res;
  if (id) {
    res = await axios.patch(`${periodosAcademicosApi}/${id}`, data, {
      headers: token({}),
    });
  } else {
    res = await axios.post(periodosAcademicosApi, data, {
      headers: token({}),
    });
  }
  return res;
};

export const onePeriodosAcademicosService = async (id) => {
  const res = await axios.get(`${periodosAcademicosApi}/${id}`, {
    headers: token({}),
  });
  return res;
};

export const deletePeriodosAcademicosService = async (id) => {
  const res = await axios.delete(`${periodosAcademicosApi}/${id}`, {
    headers: token({}),
  });
  return res;
};
